<template>

    <headerComponent />
    <router-view :key="$route.fullPath"></router-view>
    <!--<CommonQuestionComponent v-if="showQ" />
    <HomePageComponent v-else />-->
    <footerComponent />


</template>

<script>  
    
    import headerComponent from './components/Layout/headerComponent.vue'
    import footerComponent from './components/Layout/footerComponent.vue'

export default {
        name: 'App',
        data() {
            return {
                showQ:false
            }
        },        
        methods: {
            changeComponent() {
               
            }
        },
  components: {
      headerComponent,
      footerComponent,
        },
        created() {

            this.$HttpClient.initial();
        },
        mounted() {
            this.$nextTick(async function () {
                const lang = localStorage.getItem('Public_lang') || 'ar-sa';
                if (lang == 'en-us') {
                    let file = document.createElement('link');
                    file.rel = 'stylesheet';
                    file.href = process.env.BASE_URL + 'Content/assets/css/icons/icomoon/style.css';
                    document.head.appendChild(file);
                }
                else {
                    let file = document.createElement('link');
                    file.rel = 'stylesheet';
                    file.href = process.env.BASE_URL + 'Content/assets/css/icons/icomoon/style-rtl.css';
                    document.head.appendChild(file);
                }
                setTimeout(function () {
                    $('#linkStyleAr').remove();
                }, 200);
            });
        }
    }
</script>
<style>
    .show-message #swal2-html-container {
        color: white !important;
        margin-top: -30px !important;
        margin-left: 45px !important;
    }

    .show-messageAR #swal2-html-container {
        color: white !important;
        margin-top: -30px !important;
        padding-right: 45px !important;
    }

    .btn-ok {
        width: 120px;
    }

    body > .swal2-container {
        z-index: 10700;
    }
</style>


